/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let createBundleTable = (arr) => {
  let bundleHax = document.createElement("div");
  bundleHax.className = "shappify_qb_grid";
  let table = document.createElement("table");
  table.className = "shappify_qb_grid sniffie-table";
  table.style.display = "table !important";
  let theadRow = document.createElement("thead");
  let trRow = document.createElement("tr");
  let td1 = document.createElement("td");
  td1.innerText = "Aantal";
  trRow.appendChild(td1);
  let td2 = document.createElement("td");
  td2.innerText = "Prijs";
  trRow.appendChild(td2);
  let td3 = document.createElement("td");
  td3.innerText = "Korting";
  trRow.appendChild(td3);
  theadRow.appendChild(trRow);
  table.appendChild(theadRow);
  let tableBody = document.createElement("tbody");
  for (let i = 0; i < arr.length; i++) {
    let tmp = arr[i];
    trRow = document.createElement("tr");
    td1 = document.createElement("td");
    td1.innerText = arr[i].quantity;
    trRow.appendChild(td1);
    td2 = document.createElement("td");
    td2.innerText = arr[i].price;
    trRow.appendChild(td2);
    td3 = document.createElement("td");
    td3.innerText = arr[i].percentageDiff;
    trRow.appendChild(td3);
    tableBody.appendChild(trRow);
  }
  table.appendChild(tableBody);
  let shappibyItem = document.querySelector(".product-form .shappify-qty-msg");
  shappibyItem.appendChild(table);
};

let parseVariantTable = (res) => {
  let returnArray = [];
  var currentPrice = 0;
  for (let i = 0; i < res.length; i++) {
    let tmp = res[i];
    if (tmp["option1"].indexOf("+") === -1) {
      currentPrice = tmp["price"];
    }
    let tmpObj = {};
    try {
      let quantityArray = tmp["option1"]
        .split("(default) ");
      if (quantityArray.length <= 1){
        quantity = 1;
      } else {
        quantity = quantityArray[1].replace(/[^\d.-]+/g, "");
      }
      tmpObj["quantity"] = quantity;
      tmpObj["price"] = "€" + tmp["price"].replace(".", ",");
      let percentageDiff = Math.round((1-tmp["price"]/currentPrice)*100);
      if (percentageDiff < 0){
        percentageDiff = "n/a ";
      }
      tmpObj["percentageDiff"] = percentageDiff+"% korting";
      returnArray.push(tmpObj);
    } catch (err) { //
      // console.log({err});
    }
  }
  if (returnArray.length > 1) {
    try {
      createBundleTable(returnArray);
    } catch (err) {
      // console.log({ err });
    }
  }
};

try {
  var isProductPage = document.querySelector(".product-block-list");
  if (isProductPage) {
    fetch(window.location.href.split("?")[0] + ".json")
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        if (
          res?.product?.options.filter((n) => n.name === "Title").length >= 1
        ) {
          // console.log(res.product.variants);
          parseVariantTable(res.product.variants);
        }
      });
  }
} catch (err) {
  // console.log({ err });
}
